export const ROOT_ELEMENT_MOUNTED = 'stemi.web.ROOT_ELEMENT_MOUNTED';

export const rootElementMounted = meta => ({
  type: ROOT_ELEMENT_MOUNTED,
  meta,
});
